export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 64;

/** Ordered for the live checklist; reused by the validator so they can't drift. */
export const PASSWORD_RULES = [
  { key: 'length', label: '6–64 characters', test: (p: string) => p.length >= PASSWORD_MIN && p.length <= PASSWORD_MAX },
  { key: 'letter', label: 'At least one letter', test: (p: string) => /[A-Za-z]/.test(p) },
  { key: 'digit', label: 'At least one digit', test: (p: string) => /\d/.test(p) },
] as const;

export type PasswordValidationResult = { ok: true } | { ok: false; error: string };

export const PASSWORD_POLICY_MESSAGE =
  'Password must be 6–64 characters and include a letter and a digit.';

export function validatePassword(value: string): PasswordValidationResult {
  const failed = PASSWORD_RULES.find((r) => !r.test(value));
  return failed ? { ok: false, error: PASSWORD_POLICY_MESSAGE } : { ok: true };
}
